"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iRevisionConversionErrorEvent = exports.REVISION_CONVERSION_ERROR = exports.iRevisionConversionStatusEvent = exports.REVISION_CONVERSION_STATUS = void 0;
const t = require("io-ts");
const sok_types_1 = require("@caddigital/sok-types");
exports.REVISION_CONVERSION_STATUS = 'REVISION_CONVERSION_STATUS';
const iMessage = t.interface({
    revisionUuid: t.string,
    preview: t.union([sok_types_1.Preview.iPreview, t.string])
});
exports.iRevisionConversionStatusEvent = t.interface({
    event: t.literal(exports.REVISION_CONVERSION_STATUS),
    message: iMessage
});
exports.REVISION_CONVERSION_ERROR = 'REVISION_CONVERSION_ERROR';
const iError = t.interface({
    revisionUuid: t.string,
    error: t.string
});
exports.iRevisionConversionErrorEvent = t.interface({
    event: t.literal(exports.REVISION_CONVERSION_ERROR),
    message: iError
});
//# sourceMappingURL=automaticFileConversionEvent.js.map